'use client';

import dynamic from 'next/dynamic';

const CustomerTypeDialog = dynamic(
  () => import('./CustomerTypeDialog').then((m) => ({ default: m.CustomerTypeDialog })),
  { ssr: false }
);

const PushBanner = dynamic(
  () => import('./PushBanner').then((m) => ({ default: m.PushBanner })),
  { ssr: false }
);

export function LazyOverlays() {
  return (
    <>
      <CustomerTypeDialog />
      <PushBanner />
    </>
  );
}
